export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      Result: 'success',
      FunctionInfo: [
        {
          FunctionId: 5,
          FunctionName: 'ビデオチャット機能',
          DeliveryType: '',
          DeliveryTypeId: 2,
          Status: 1
        },
        {
          FunctionId: 4,
          FunctionName: '警戒レベル告知機能',
          DeliveryType: 'keikai',
          DeliveryTypeId: 6,
          Status: 1
        },
        {
          FunctionId: 3,
          FunctionName: 'スマホ連携機能',
          DeliveryType: ' family_info',
          DeliveryTypeId: 1,
          Status: 1
        },
        {
          FunctionId: 2,
          FunctionName: '御用聞き機能',
          DeliveryType: 'ordertake',
          DeliveryTypeId: 5,
          Status: 1
        },
        {
          FunctionId: 1,
          FunctionName: '見守り機能',
          DeliveryType: ' follow',
          DeliveryTypeId: 4,
          Status: 1
        }
      ]
    }
  }
}